import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "9",
  height: "15",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M8.707 8.207a1 1 0 0 0 0-1.414L2.343.429A1 1 0 0 0 .93 1.843L6.586 7.5.929 13.157a1 1 0 1 0 1.414 1.414zM7 8.5h1v-2H7z" }, null, -1)
  ]))]))
}
export default { render: render }